// Internal Dependencies
import FixedButton from './fixed-button';

$(window).on('et_builder_api_ready', (event, API) => {
  API.registerModules([FixedButton]);
});
